module.exports = function anonymous(it
/**/) {
var out='<div data-widget="GalleryOverlay" class="overlay overlay--gallery" id="galleryOverlay"> <div class="overlay__inner1"> <div class="overlay__inner2"> <div class="overlay__inner3"> <div class="overlay__header"> <button class="overlay__close" data-overlay-close><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg-defs-sprite.svg#close"></use></svg><span class="a11y">Close overlay</span></button> </div> <div data-gallery-items> </div> </div> </div> </div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/galleryOverlay.dot
// module id = 237
// module chunks = 0 1